import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		entities: [],
		customersTypes: []
	},

	actions: {
		fetchAll({ commit }, { entityType, name: query, regionId }) {
			return window.axios.get('/entitiesWithTypeId/all', {
				params: {
					entityType,
					query,
					regionId,
				}
			})
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		fetchAllData({ commit }, { typeId, name, perPage }) {
			return window.axios.get('/entitiesWithTypeId', {
				params: {
					typeId,
					name,
					includeContactInfo: true,
					includeAddresses: true,
					nonDeleted: true,
					page: 1,
					perPage
				}
			})
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		fetchMatchedEntities({ commit }, { name, regionId }) {
			return window.axios.get('/entityExistCheck', { params: { name, regionId } })
				.then(({ data }) => data)
		},

		modify({ commit }, { 
			requestType,
			entityId,
			typeId,
			name,
			reason,
			specialtyId,
			entityAddresses,
			contactInfos,
			entityType,
			loyality,
			relegion,
			personality,
			birthdate,
			weekend,
			personalNote,
			customerInfo,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			pmWorkHour,
			amWorkHour,
			ownerInfo,
			residentDoctorNames
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion
            */
			return window.axios.post('/requests/entitymodifications',
				{ 
					entityType,
					requestType,
					entityId,
					typeId,
					name,
					reason,
					specialtyId,
					entityAddresses,
					contactInfos,
					loyality,
					relegion,
					personality,
					birthdate,
					weekend,
					personalNote,
					customerInfo,
					hobbies,
					nearbyPointOfSales,
					visitNotes,
					worksInCenters,
					pmWorkHour,
					amWorkHour,
					ownerInfo,
					residentDoctorNames
				})
		},
	
		directModify({ commit }, { 
			requestType, 
			entityId, 
			typeId, 
			name, 
			reason, 
			specialtyId, 
			entityAddresses, 
			contactInfos, 
			entityType,
			// new
			loyality,
			relegion,
			personality,
			birthdate,
			amWorkHour,
			pmWorkHour,
			// weekend,
			residentDoctorNames,
			personalNote,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			customerInfo,
			ownerInfo,
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion

                entityType:
                0 = Center
                1 = Doctor
                2 = Pharmacy
                3 = External
            */
			return window.axios.post('/requests/EntityModifications/AddEntityWithRequest', { 
				requestType, 
				entityId, 
				typeId, 
				name, 
				reason, 
				specialtyId, 
				entityAddresses, 
				contactInfos, 
				entityType,
				// new
				loyality,
				relegion,
				personality,
				birthdate,
				amWorkHour,
				pmWorkHour,
				// weekend,
				residentDoctorNames,
				personalNote,
				hobbies,
				nearbyPointOfSales,
				visitNotes,
				worksInCenters,
				customerInfo,
				ownerInfo
			})
		},

		fetchEntityType ({ commit }) { 
			return window.axios.get('/entities/types', { once: true }).then(({ data }) => {
				commit(types.STORE_CUSTOMERS_TYPES, data)
				return data
			})
		},

		reset({ commit }) {
			commit(types.RESET_ENTITIES);
		}
	},

	mutations: {
		[types.STORE_ENTITIES](state, entities) {
			state.entities = entities;
		},
        
		[types.RESET_ENTITIES](state) {
			state.entities = [];
		},

		[types.STORE_CUSTOMERS_TYPES](state, customersTypes) {
			state.customersTypes = customersTypes
		},
	},

	getters: {
		getEntityById: state => id => state.entities.find(c => c.id === id)
	}
}